import { createApp } from '@app/adapters/create-app'
import CompanyInboxV2 from '@app/application/communication/screens/inbox/components/company-inbox-v2.vue'
import { startOnce } from '@app/adapters/tutorial'
import createInboxV2Store from '@app/application/communication/screens/inbox/store/inbox-v2'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company-inbox']").each(function () {
    const endpointParams = {
      companyId: Silverfin.currentCompanyId,
      ledgerId: Silverfin.currentLedgerId(),
      firmId: Silverfin.currentFirmId,
    }

    const companyInboxApp = createApp(CompanyInboxV2, {
      initialCategory: $(this).data('category'),
      initialItem: $(this).data('item'),
    })
    const store = createInboxV2Store(endpointParams)

    companyInboxApp.use(store)
    companyInboxApp.mount(this)

    /* TODO: Manually trigger the corresponding Userlane tutorial until they fix their JS performance
    See https://gitlab.silverfin.com/development/silverfin/-/issues/18067 */
    if (typeof this.dataset.tutorialId !== 'undefined') {
      startOnce(this.dataset.tutorialId)
    }

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: true,
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialAuthors:
          $(this)
            .data('authors')
            ?.toString()
            ?.split(',')
            ?.map((value) =>
              value === 'external' ? value : Number.parseInt(value)
            ) || [],
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
